import { ref } from "vue";
const modals = ref({});
const currentModal = ref(null);
const useModalPage = () => {
  const register = ({ name, component, props, modalProps }) => {
    modals.value[name] = {
      component,
      props,
      modalProps
    };
  };
  const show = ({ name, component, props, modalProps }) => {
    const modal = name ? modals.value[name] : { component };
    if (modal) {
      currentModal.value = {
        component: modal.component,
        props: {
          ...modal.props,
          ...props
        },
        modalProps: {
          ...modal.modalProps,
          ...modalProps
        }
      };
    }
  };
  const hide = (props) => {
    if (currentModal.value) {
      currentModal.value = null;
    }
  };
  return {
    modals,
    currentModal,
    register,
    show,
    hide
  };
};
export {
  useModalPage
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
